import { HTTP_STATUS } from '@/constants/http.constants';
import { isApiError } from '@/services/http/api-error';
import { ERROR_CODES } from '@/types/api.types';

import { type FieldErrors, issuesToFieldErrors } from './validation';

/** A sentence the user can act on, for any error the app can throw. */
export function getErrorMessage(error: unknown): string {
  if (isApiError(error)) {
    if (error.isNetworkError) {
      return 'Cannot reach the Club29 server. Check the internet connection and try again.';
    }
    if (error.status === HTTP_STATUS.FORBIDDEN) {
      return error.message || 'You do not have access to do this.';
    }
    if (error.status >= HTTP_STATUS.INTERNAL_SERVER_ERROR) {
      const reference = error.requestId ? ` (reference ${error.requestId})` : '';
      return `Something went wrong on the server${reference}. Please try again.`;
    }
    return error.message;
  }
  if (error instanceof Error) return error.message;
  return 'Something went wrong. Please try again.';
}

/** Field-level messages from a 422, keyed by field name (`mobile`, `email`, …). */
export function getFieldErrors(error: unknown): FieldErrors {
  if (isApiError(error) && error.code === ERROR_CODES.VALIDATION_ERROR && error.details) {
    return issuesToFieldErrors(error.details);
  }
  return {};
}
